import MY_LS from 'utils/myLittleStorage'
import LocalStorage from 'utils/myLocalStorage'
import axios from './axios'
import UrlApis from './urlApis'
import { HTTP_CODES } from 'constants/constants'

const VERBS = {
  GET: 'GET',
  PUT: 'PUT',
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  OPTIONS: 'OPTIONS',
  HEAD: 'HEAD',
  TRACE: 'TRACE',
  /* Extra verbs */
  GET_DOCUMENT: 'GET_DOCUMENT',
}

const HEADERS = {
  HEADER_SIGN_IN_OUT: 'HEADER_SIGN_IN_OUT',
  HEADER_READ: 'HEADER_READ',
  HEADER_CREATE: 'HEADER_CREATE',
  HEADER_UPDATE: 'HEADER_UPDATE',
}

export const MUTATION_VERBS_HEADER = {
  PUT: HEADERS.HEADER_UPDATE,
  POST: HEADERS.HEADER_CREATE,
  DELETE: HEADERS.HEADER_UPDATE,
}

/*
Request-header used for login + logout
 */
const HEADER_SIGN_IN_OUT = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': VERBS.POST,
}

/*
Request-header used for all versb without update (GET, TRACE, HEAD, OPTIONS)
 */
const HEADER_READ = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': [VERBS.GET, VERBS.TRACE, VERBS.HEAD, VERBS.OPTIONS].join(','),
}

/*
Request-header used for all versb associated to a creation (POST, PUT)
 */
const HEADER_CREATE = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': [VERBS.POST, VERBS.PUT].join(','),
}

/*
Request-header used for all versb associated to a (possible) update (POST, PUT, PATCH, DELETE)
 */
const HEADER_UPDATE = {
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': [VERBS.POST, VERBS.PUT, VERBS.PATCH, VERBS.DELETE].join(','),
}

/*
Request-header used for fetching a binary document
 */
const HEADER_GET_DOCUMENT = {
  'Content-Type': 'application/octet-stream',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': [VERBS.GET].join(','),
}

const requestCsrf = async () => {
  // Get CSRF token (required for https-VERB such as PUT, POST, etc.
  console.debug('csrf-token required ...')
  return axios
    .get(
      UrlApis.URL_SPECIAL_CSRF_GET,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET',
        },
        withCredentials: false,
      },
    )
    .then((response) => {
      const csrfToken = response?.data?.token
      console.debug('csrf response received! --> token =' + csrfToken)

      MY_LS.put([MY_LS.TOKEN_CSRF], csrfToken)
      return csrfToken
    })
    .catch((err) => {
      return LocalStorage.VALUE_TYPE.NOT_FOUND
    })
}

// Complete header with CSRF token stored within My Little Storage
const getHeader = (header) => {
  let headerCompleteToReturn = undefined
  switch (header) {
    case HEADERS.HEADER_READ:
      // Header not requiring CSRF
      headerCompleteToReturn = HEADER_READ
      break

    case HEADERS.HEADER_GET_DOCUMENT:
      // Header not requiring CSRF
      headerCompleteToReturn = HEADER_GET_DOCUMENT
      break

    default:
      // Header requiring CSRF
      return requestCsrf()
        .then((csrfToken) => {
          let headerCompleteToReturn = undefined
          switch (header) {
            case HEADERS.HEADER_SIGN_IN_OUT:
              headerCompleteToReturn = HEADER_SIGN_IN_OUT
              headerCompleteToReturn['X-CSRF-TOKEN'] = csrfToken
              break

            case HEADERS.HEADER_CREATE:
              headerCompleteToReturn = HEADER_CREATE
              headerCompleteToReturn['X-CSRF-TOKEN'] = csrfToken
              break

            case HEADERS.HEADER_UPDATE:
              headerCompleteToReturn = HEADER_UPDATE
              headerCompleteToReturn['X-CSRF-TOKEN'] = csrfToken
              break

            default:
              break
          }
          return headerCompleteToReturn
        })
        .catch((err) => {
          alert('ERR: CSRF-token could not be retrieved remotly! ' + err)
          console.debug('ERR: CSRF-token could not be retrieved remotly!')
          return LocalStorage.VALUE_TYPE.NOT_FOUND
        })
  }

  return headerCompleteToReturn
}

const processError = (err) => {
  let strErr = ''

  if (!err?.response) {
    strErr = 'No Server Response'
  } else if (err.response?.status === HTTP_CODES.HTTP_CODE_SESSION_EXPIRED) {
    strErr = 'Not Allowed access to server Amasis'
  } else if (err.response?.status === 401) {
    strErr = 'Error'
  } else {
    strErr = 'Server Down'
  }

  return strErr
}

const AxiosUtils = { VERBS, HEADERS, getHeader, processError }
export default AxiosUtils
